import { type FunctionComponent, lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCuratePageAccount = lazy(() => {
  return new Promise<{ default: FunctionComponent }>((resolve, reject) => {
    import("@honeycomb/curate/curate.css");
    import("@honeycomb/curate")
      .then((lib) => {
        resolve({
          default: () => <lib.PageAccount />,
        });
      })
      .catch(reject);
  });
});

export const LazyCuratePageAccount = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCuratePageAccount />
    </Suspense>
  );
};
